
import api from './api';

const pacienteService = {
  // Buscar histórico de procedimentos do paciente
  historico: async (id) => {
    const response = await api.get(`/pacientes/${id}/historico`);
    return response;
  },
  listar: async ({ page = 1, limit = 20, busca = '' } = {}) => {
    const params = new URLSearchParams({ page, limit });
    if (busca) params.set('busca', busca);
    const response = await api.get(`/pacientes?${params.toString()}`);
    return response;
  },

  // Buscar paciente por ID
  buscarPorId: async (id) => {
    const response = await api.get(`/pacientes/${id}`);
    return response; // Interceptor já retorna response.data
  },

  // Criar novo paciente
  criar: async (dados) => {
    const response = await api.post('/pacientes', dados);
    return response; // Interceptor já retorna response.data
  },

  // Atualizar paciente
  atualizar: async (id, dados) => {
    const response = await api.put(`/pacientes/${id}`, dados);
    return response; // Interceptor já retorna response.data
  },

  // Deletar paciente
  deletar: async (id) => {
    const response = await api.delete(`/pacientes/${id}`);
    return response; // Interceptor já retorna response.data
  },

  // Buscar pacientes (para autocomplete)
  buscar: async (termo = '') => {
    const response = await api.get('/pacientes/buscar', {
      params: { termo }
    });
    return response; // Interceptor já retorna response.data
  },

  // Resumo financeiro do paciente
  financeiro: async (id) => {
    const response = await api.get(`/faturamento/paciente/${id}/resumo`);
    return response;
  },
};

export default pacienteService;
